import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { FileText, Award } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { RecordCard, UploadButton } from './RecordHelpers';

export const CorporateBooksTab = ({ minutesBook, resolutionsBook, certificates, term, onArchive, onUploadOpen }) => (
  <div className="space-y-6">
    <div className="flex justify-end"><UploadButton tab="corporate-books" defaultType="certificate" onOpen={onUploadOpen} /></div>
    {/* Minutes */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><FileText className="h-4 w-4 text-[#00A3A3]" />Minutes Book</h3>
      {minutesBook.filter(m => (m.title || '').toLowerCase().includes(term)).length === 0 ? (
        <p className="text-xs text-[#A8B1B9] italic">No approved minutes yet</p>
      ) : (
        <div className="space-y-2">
          {minutesBook.filter(m => (m.title || '').toLowerCase().includes(term)).map(m => (
            <Card key={m.id} className="border-[#E2E6EA]"><CardContent className="p-3 flex items-center gap-3">
              <div className="p-1.5 bg-[#00A3A3]/10 rounded"><FileText className="h-4 w-4 text-[#00A3A3]" /></div>
              <div className="flex-1 min-w-0"><p className="text-sm font-medium text-[#1A1D21] truncate">{m.title}</p><p className="text-[10px] text-[#A8B1B9]">{m.created_at ? format(parseISO(m.created_at), 'MMM d, yyyy') : ''}</p></div>
              <Badge className="bg-green-100 text-green-800 text-[10px]">Approved</Badge>
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
    {/* Resolutions */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><Award className="h-4 w-4 text-[#F58A26]" />Resolutions Book</h3>
      {resolutionsBook.filter(r => (r.title || '').toLowerCase().includes(term)).length === 0 ? (
        <p className="text-xs text-[#A8B1B9] italic">No approved resolutions yet</p>
      ) : (
        <div className="space-y-2">
          {resolutionsBook.filter(r => (r.title || '').toLowerCase().includes(term)).map(r => (
            <Card key={r.id} className="border-[#E2E6EA]"><CardContent className="p-3 flex items-center gap-3">
              <div className="p-1.5 bg-[#F58A26]/10 rounded"><Award className="h-4 w-4 text-[#F58A26]" /></div>
              <div className="flex-1 min-w-0">
                <p className="text-[10px] font-mono text-[#00A3A3]">{r.resolution_number}</p>
                <p className="text-sm font-medium text-[#1A1D21] truncate">{r.title}</p>
              </div>
              <Badge className="bg-green-100 text-green-800 text-[10px]">Approved</Badge>
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
    {/* Certificates */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><Award className="h-4 w-4 text-[#00A3A3]" />Certificates</h3>
      {certificates.filter(r => (r.title || '').toLowerCase().includes(term)).length === 0 ? (
        <p className="text-xs text-[#A8B1B9] italic">No certificates yet</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-3">
          {certificates.filter(r => (r.title || '').toLowerCase().includes(term)).map(r => (
            <RecordCard key={r.id} record={r} icon={<Award className="h-5 w-5 text-[#00A3A3]" />} onArchive={onArchive} />
          ))}
        </div>
      )}
    </div>
  </div>
);
